var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{staticClass:"mb-5 table-dropdown no-scrollbar border rounded document_request_dropdown",attrs:{"empty-text":this.$t('there_are_no_records'),"bordered":"","striped":"","responsive":"","items":_vm.transferRequest,"fields":_vm.transferRequestsFields,"show-empty":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }